const ITEMS = [
    "CAROTARE BETON ARMAT",
    "TĂIERI CU DISC DIAMANTAT",
    "DEMOLĂRI CONTROLATE",
    "ȘLEFUIRE INDUSTRIALĂ",
    "REPASTILARE CAROTE",
    "TEHNOLOGIE DIAMANTATĂ",
];

const Track = () => (
    <div className="flex shrink-0 items-center gap-12 pr-12">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center gap-12">
                <span className="font-display text-2xl font-bold uppercase tracking-tight text-paper/75 lg:text-3xl">
                    {item}
                </span>
                <span className="inline-block h-2.5 w-2.5 rotate-45 bg-flame" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div
            data-testid="brand-marquee"
            className="overflow-hidden border-y border-line bg-coal py-7"
        >
            <div className="flex w-max animate-marquee">
                <Track />
                <Track />
            </div>
        </div>
    );
}